export default {
  pageTitle: 'WMS仓储管理系统',
  allRobots: '全部机器人',
  smtRobotName: '工业SMT上下料机器人',
  mockRobotIdleName: 'AVG1',
  mockRobotChargingName: 'AVG2',
  taskQueue: '任务队列',
  robotStatus: '机器人状态',
  currentTaskDetail: '当前任务详情',
  tabAll: '全部',
  tabPending: '待执行',
  tabRunning: '执行中',
  tabCompleted: '已完成',
  tabError: '异常',
  sourceLocation: '来源库位',
  targetLocation: '目标',
  targetPosition: '目标位置',
  defaultTarget: 'SMT产线A区',
  executeRobot: '执行机器人',
  eta: '预计送达',
  etaSeconds: '{n}秒',
  etaMinutes: '{n}分钟',
  etaMinutesSeconds: '{m}分{s}秒',
  taskId: '任务编号',
  material: '物料',
  taskProgress: '任务进度',
  unitOrder: '单',
  unitRobot: '台',
  unitAlert: '条',
  statTotalToday: '今日任务总数',
  statCompleted: '已完成任务',
  statCompletionRate: '任务完成率',
  statRunningRobots: '运行机器人',
  statAlerts: '异常告警',
  statPending: '待处理任务',
  statusPending: '待执行',
  statusRunning: '执行中',
  statusCompleted: '已完成',
  statusError: '异常',
  robotRunning: '运行中',
  robotIdle: '待命',
  robotPicking: '取料中',
  robotCharging: '充电中',
  emptyTask: '暂无任务',
  emptyRobot: '暂无机器人',
  emptyDetail: '请选择任务查看详情',
  shipmentOrderTitle: '发运订单',
  colOrderNo: '发运订单编号',
  colOrderType: '订单类型',
  colProductTypes: '包含产品类型',
  colOrderStatus: '发运订单状态',
  colOwner: '货主',
  colWarehouseNo: '仓库编号',
  colConsignee: '收货人',
  orderTypeProduction: '生产领料单',
  productTypeRaw: '原材料',
};
